
import FButtonOptions from '@/components/atoms/forms/h-button-options';
import FButtonOptionsGroup from '@/components/atoms/forms/h-button-options-group';
import FCurrencyField from '@/components/atoms/forms/h-currency-field';
import FPercentageField from '@/components/atoms/forms/h-percentage-field';
import FSelect from '@/components/atoms/forms/h-select';
import FSwitch from '@/components/atoms/forms/h-switch';
import FTextField from '@/components/atoms/forms/h-text-field';
import FInfoTooltip from '@/components/molecules/tooltips/info-tooltip';

export default {
  name: 'CalculatorInput',

  components: {
    FButtonOptions,
    FButtonOptionsGroup,
    FCurrencyField,
    FPercentageField,
    FSelect,
    FSwitch,
    FTextField,
    FInfoTooltip,
  },

  props: {
    disabled: {
      type: Boolean,
    },
    disabledPlaceholder: {
      default: '',
      type: [String, Number, null],
    },
    enabledModel: {
      default: undefined,
      type: [Object, Boolean],
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    errorMessageFullWith: {
      type: Boolean,
      default: false,
    },
    label: {
      default: '',
      type: String,
    },
    inputMode: {
      type: String,
      default: undefined,
    },
    options: {
      default: () => [],
      type: Array,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    prefix: {
      default: '',
      type: String,
    },
    suffix: {
      default: '',
      type: String,
    },
    tooltip: {
      default: '',
      type: String,
    },
    /*
      enum type = {
        text
        number
        select
        percentage
        currency
        button-options
      }
    */
    type: {
      default: 'text',
      type: String,
    },
    value: {
      default: '',
      type: [String, Number, Boolean, null],
    },
    areInitialValuesSet: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      isMounted: false,
    };
  },

  computed: {
    isReady() {
      return this.isMounted && this.areInitialValuesSet;
    },
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    handleBlur(e) {
      this.$emit('blur', e);
    },

    handleFocus(e) {
      this.$emit('focus', e);
    },

    handleChange(value) {
      this.$emit('change', value);
    },

    handleInput(value) {
      this.$emit('input', value);
    },

    onEnabledChange(value) {
      this.$emit('toggle-change', value);
    },
  },
};
